module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-04-21 at 10.16.21 AM.8d66da8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Screen Shot 2020-04-21 at 10.16.21 AM.png
// module id = 386
// module chunks = 0